
import Vue from 'vue';
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(
    'section',
    { staticClass: 'a404page' },
    [
      _c('secondary-nav'),
      _c(
        'div',
        { staticClass: 'su-body' },
        [
          _c('div', { staticClass: 'su-section-seven container su-section-contact' }, [
            _c('div', { staticClass: 'row' }, [
              _c('div', { staticClass: 'col-1 void-column' }),
              _c('div', { staticClass: 'col-12 col-md-11' }, [
                _c('div', { staticClass: 'row expetation-title' }, [
                  _c('div', { staticClass: 'col-12' }, [
                    _c('p', [_vm._v('Become our')]),
                    _c('h1', [_vm._v('Technician')]),
                    _c('p', [
                      _vm._v(
                        ' We are currently looking for talented and experienced Light Technician and Sound Technician to join our team at Showup Productions. Please read the skills required before applying. ',
                      ),
                    ]),
                  ]),
                ]),
                _c('div', { staticClass: 'row expetation-body' }, [
                  _c('div', { staticClass: 'col-12' }, [
                    _c('h4', [_vm._v('LIGHT TECHNICIAN')]),
                    _c('ul', [
                      _c('div', { staticClass: 'row' }, [
                        _c('li', { staticClass: 'col-md-6 col-12' }, [
                          _vm._v(
                            ' Demonstrated programming proficiency on the GrandMA2 and 3 series of lighting consoles. ',
                          ),
                        ]),
                        _c('li', { staticClass: 'col-md-6 col-12' }, [
                          _vm._v(
                            ' Intermediate level of lighting design skills to accommodate special events in the venue. ',
                          ),
                        ]),
                      ]),
                      _c('div', { staticClass: 'row' }, [
                        _c('li', { staticClass: 'col-md-6 col-12' }, [
                          _vm._v(
                            ' Ability to learn DisguiseArena Resolume, Pandora\u2019s Box, Catalyst, Arkaos, Media server to a level sufficient for troubleshooting, basic content loading, and proper output routing. ',
                          ),
                        ]),
                        _c('li', { staticClass: 'col-md-6 col-12' }, [
                          _vm._v(
                            ' Regularly inspect all LED Video surfaces, replacing panels as required. ',
                          ),
                        ]),
                      ]),
                      _c('div', { staticClass: 'row' }, [
                        _c('li', { staticClass: 'col-md-6 col-12' }, [
                          _vm._v(
                            ' Regularly safety inspect and maintain lighting gear in the venue. ',
                          ),
                        ]),
                        _c('li', { staticClass: 'col-md-6 col-12' }, [
                          _vm._v(
                            ' Effectively troubleshoot and report on all lighting or video issues. ',
                          ),
                        ]),
                      ]),
                      _c('div', { staticClass: 'row' }, [
                        _c('li', { staticClass: 'col-md-6 col-12' }, [
                          _vm._v(
                            ' Preset, program (as applicable), and run all events taking place in assigned venue. ',
                          ),
                        ]),
                        _c('li', { staticClass: 'col-md-6 col-12' }, [
                          _vm._v(' Availability to embark for 6-8 months contract. '),
                        ]),
                      ]),
                    ]),
                    _c('h4', { staticClass: 'mt-4' }, [_vm._v('SOUND TECHNICIAN')]),
                    _c('ul', [
                      _c('div', { staticClass: 'row' }, [
                        _c('li', { staticClass: 'col-md-6 col-12' }, [
                          _vm._v(
                            ' Demonstrated programming proficiency on the QLab platform and Logic DAW. ',
                          ),
                        ]),
                        _c('li', { staticClass: 'col-md-6 col-12' }, [
                          _vm._v(
                            ' Preset, program (as applicable), and run all events taking place in assigned venue. ',
                          ),
                        ]),
                      ]),
                      _c('div', { staticClass: 'row' }, [
                        _c('li', { staticClass: 'col-md-6 col-12' }, [
                          _vm._v(' Demonstrated knowledge of the DANTE protocol. '),
                        ]),
                        _c('li', { staticClass: 'col-md-6 col-12' }, [
                          _vm._v(
                            ' Demonstrated knowledge of YAMAHA digital mixers (QL5, CL5, M7CL, LS9). ',
                          ),
                        ]),
                      ]),
                      _c('div', { staticClass: 'row' }, [
                        _c('li', { staticClass: 'col-md-6 col-12' }, [
                          _vm._v(
                            ' Knowledge of the MIDI protocol and consequent synchronization programming. ',
                          ),
                        ]),
                        _c('li', { staticClass: 'col-md-6 col-12' }, [
                          _vm._v(' Availability to embark for 6-8 months contract. '),
                        ]),
                      ]),
                    ]),
                    _c('div', { staticClass: 'row mt-4' }, [
                      _c('div', { staticClass: 'col-12' }, [
                        _c(
                          'a',
                          {
                            staticClass: 'su-button',
                            attrs: { href: 'https://forms.monday.com/forms/a922ea43f57538131589fc86befc3209?r=euc1', target: '_blank' },
                          },
                          [_vm._v('Apply with us')],
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _c('footer-row'),
          _c('alert-row', { ref: 'alertMsg' }),
        ],
        1,
      ),
    ],
    1,
  );
};
var staticRenderFns = [];

export default Vue.extend({ render, staticRenderFns });
